var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import React, { Component } from 'react';
import DiagnosisCardAPI from './diagnosis-card-api';
import { generateUUID, isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import clinicalNotesImage from '../../assets/images/global/clinical-notes-40x40.svg';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import './diagnosis-card.css';
import { Avatar, Card } from '@philips-internal/oswald-ui-components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
var StatusType;
(function (StatusType) {
    StatusType["ACTIVE"] = "A";
})(StatusType || (StatusType = {}));
let DiagnosisCard = class DiagnosisCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { sequenceNumber, status, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        sequenceNumber,
                        status
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    renderIndicatorColorStatus() {
        const { status } = this.props;
        if (status?.toUpperCase() === StatusType.ACTIVE) {
            return React.createElement("div", { className: 'c-diagnosis-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-diagnosis-card__indicator-color-orange' });
    }
    getStatusIcon() {
        const { status } = this.props;
        if (status?.toUpperCase() === StatusType.ACTIVE) {
            return React.createElement(ReleasedIcon, { className: 'c-diagnosis-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-diagnosis-card__color-orange' });
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-diagnosis-card__status' }, this.getStatusIcon()));
    }
    renderAvatar() {
        const { diseaseDescription, physicianName } = this.props;
        return (React.createElement("div", { className: 'c-diagnosis-card__cn-avatar' },
            this.renderStatus(),
            React.createElement(Avatar, { image: clinicalNotesImage, title: diseaseDescription, subtitle: physicianName })));
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-diagnosis-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    render() {
        const legends = [
            {
                color: 'signal-green-60',
                icon: React.createElement(ReleasedIcon, null),
                label: MessageService.translate('text.finished'),
                value: MessageService.translate('text.finished')
            },
            {
                color: 'signal-orange-45',
                icon: React.createElement(PendingIcon, null),
                label: MessageService.translate('tws.label-pending'),
                value: MessageService.translate('tws.label-pending')
            }
        ];
        const { sequenceNumber } = this.props;
        return (React.createElement(Card, { className: 'c-diagnosis-main', selectionType: SelectionType.SINGLE, superscription: legends, uuid: generateUUID(), width: 12, key: sequenceNumber },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-diagnosis-card__cn-wrapper', onClick: () => this.onClick() }, this.renderAvatar())));
    }
};
DiagnosisCard = __decorate([
    AwesomeComponent({ api: DiagnosisCardAPI, type: ComponentType.DATA_DISPLAY })
], DiagnosisCard);
export default DiagnosisCard;
//# sourceMappingURL=diagnosis-card.js.map